import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import Select from "react-select";
import useOverviewContext from "../../store/use-overview-context";

const TagSelect = ({ options = [], onChange }) => {
  const [value, setValue] = useState([]);

  const changeHandler = (option) => {
    setValue((prevValue) => {
      let newValue;
      if (prevValue.map(v => v.value).includes(option.value)) {
        newValue = prevValue.filter((v) => v .value !== option.value);
      } else {
        newValue = [...prevValue, option];
      }

      onChange(newValue);
      return newValue;
    });
  };

  return (
    <>
      {options.map((tag) => (
        <span
          key={tag.value}
          onClick={() => changeHandler(tag)}
          className={classNames({
            active: value.map(v => v.value).includes(tag.value),
          })}
        >
          {tag.label}
        </span>
      ))}
    </>
  );
};

const FiltersControlFacet = ({ id, label, multiple }) => {
  const { facetSelector, facets, setFilter, removeFilter } =
    useOverviewContext();

  if (!facets || !facets.length) {
    // no facets available yet
    return null;
  }

  const facet = facets.find((facet) => facet.key === id);

  if (!facet) {
    console.error(`Facet not found: ${facetSelector}`);
    return null;
  }

  if (!facet.count || !facet.results || facet.results.length === 0) {
    // console.error(`Facet has no values: ${facetSelector}`);
    return null;
  }

  const possibleFacets = facet.results;
  possibleFacets.sort((a, b) => a.label.localeCompare(b.label));

  const customOptions = possibleFacets.map((term) => ({
    label: term.label,
    value: term.key,
  }));

  const changeHandler = (value) => {
    if (!value?.length) {
      removeFilter(id)
      return;
    }

    if (multiple) {
      setFilter(
        id,
        value.map((v) => v.value)
      );
    } else {
      setFilter(id, [value.value]);
    }
  };

  return (
    <div className={`taxonomy-filter ${label.toLowerCase()}`}>
      <TagSelect options={customOptions} onChange={changeHandler} />
      {/* <Select
        options={customOptions}
        placeholder={label}
        isMulti={multiple}
        name={id}
        classNamePrefix="facet-select"
        isClearable
        onChange={changeHandler}
      /> */}
    </div>
  );
};

FiltersControlFacet.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default FiltersControlFacet;
